import {
    SET_USER_ORG,
    RESET_ORG_CREATION_STATE,
    SET_PRIMARY_ORG,
    GET_ORGS_COLLECTION_SUCCESS,
    SET_SELECTED_ORG,
    UPDATE_ORG_IMAGE,
    UPDATE_ORG_IMAGE_SUCCESS,
    UPDATE_ORG_IMAGE_FAILURE,
    VALIDATE_SHORT_CODE,
    SET_SHORT_CODE_VALIDATION_RESULT
} from '../actions/types';

const INITIAL_STATE = {
    orgs: null,
    selectedOrg: null,
    defaultRoles: null,
    loadingDefaultRoles: false,
    defaultRolesLoadError: null,
    creatingOrg: false,
    orgCreationError: null,
    newOrgName: null,
    primaryOrg: null,
    uploadingOrgImage: false,
    uploadOrgImageSuccess: false,
    uploadOrgImageError: null,
    isShortCodeValid: null,
    shortCodeValidationError: null,
    shortCodeValidationChecked: false
};

const alphabetizedOrgs = orgs => {
    if (orgs.length > 1) return orgs.sort((a, b) => a.org_name.localeCompare(b.org_name));
    return orgs;
};

const orgReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ORGS_COLLECTION_SUCCESS:
        case SET_USER_ORG:
            return {
                ...state,
                orgs: alphabetizedOrgs(action.payload.orgs)
            };
        case RESET_ORG_CREATION_STATE:
            return {
                ...state,
                creatingOrg: false,
                orgCreationError: null,
                newOrgName: null
            };
        case SET_PRIMARY_ORG:
            return {
                ...state,
                primaryOrg: action.payload
            };
        case SET_SELECTED_ORG:
            return {
                ...state,
                selectedOrg: action.payload
            };
        case UPDATE_ORG_IMAGE:
            return {
                ...state,
                uploadingOrgImage: true,
                uploadOrgImageSuccess: false,
                uploadOrgImageError: null
            };
        case UPDATE_ORG_IMAGE_SUCCESS:
            return {
                ...state,
                uploadingOrgImage: false,
                uploadOrgImageSuccess: action.payload,
                uploadOrgImageError: null
            };
        case UPDATE_ORG_IMAGE_FAILURE:
            return {
                ...state,
                uploadingOrgImage: false,
                uploadOrgImageSuccess: false,
                uploadOrgImageError: action.payload
            };
        case VALIDATE_SHORT_CODE:
            return {
                ...state,
                isShortCodeValid: null,
                shortCodeValidationError: null
            };
        case SET_SHORT_CODE_VALIDATION_RESULT:
            return {
                ...state,
                isShortCodeValid: action.payload.isValid,
                shortCodeValidationChecked: true,
                shortCodeValidationError: action.payload.errorMessage
            };
        default:
            return state;
    }
};

export default orgReducer;
